import styled from 'styled-components';
export const VoucherPolicyContainer = styled.div ``;
export const VoucherPolicyHeading = styled.div `
    cursor: pointer;
    margin-top: 10px;
    text-align: left;

    svg {
        margin-left: 6.5px;
        margin-top: -3px;
        transition: transform 0.1s ease-out;
        transform: rotate(0deg);
    }

    ${({ isCollapsed }) => !isCollapsed &&
    `
    svg {
            transform: rotate(180deg);
        }
    `}
`;
export const VoucherPolicyContent = styled.div `
    margin-top: 4px;
    text-align: left;
`;
export const LeftAlignedText = styled.div `
    text-align: left;
`;
export const SmallFont = styled.span `
    font-size: 10px;
    line-height: 14px;
    & a {
        text-decoration: underline;
        color: ${props => { var _a; return (_a = props.theme.functionColor) === null || _a === void 0 ? void 0 : _a.function80; }};
    }
`;
//# sourceMappingURL=styles.js.map